<template lang="pug">
div.is-flex.is-justify-content-center.is-align-items-center(style="height: calc(100vh - 52px);")
  b-notification(
    :type="status === 'error' ? 'is-danger' : status === 'success' ? 'is-success' : undefined"
    :closable="false"
  )
    p {{ message }}
    b-loading(
      v-model="isLoading"
      :is-full-page="false"
      :can-cancel="false"
    )
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
      merchantToken: null,
      nr: null,
      id: null,
      status: undefined,
      message: 'Daten werden geladen...',
    };
  },
  created() {
    this.merchantToken = this.$route.params.merchantToken;
    this.nr = this.$route.params.nr;
    this.id = this.$route.params.id;

    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.message = 'Daten werden geladen...';
      this.isLoading = true;

      try {
        const orderAddParams = new URLSearchParams({
          merchantToken: this.merchantToken,
          nr: this.nr,
          id: this.id,
        });

        const response = await fetch(`/order/cancel?${orderAddParams.toString()}`);
        if (!response.ok) {
          const errorData = await response.json();
          throw errorData || { message: 'Es ist ein Fehler aufgetreten.', status: response.status };
        }

        const data = await response.json();
        if (!data.success) {
          this.status = 'error';
          this.message = data.errorMessage || 'Es ist ein Fehler aufgetreten.';
          return;
        }

        this.status = 'success';
        this.message = 'Der bezahl.de Vorgang wurde erfolgreich archiviert.';
      } catch (e) {
        this.status = 'error';
        this.message = e?.error || 'Es ist ein Fehler aufgetreten.';
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
